import React from 'react';
import { motion } from 'framer-motion';
import { Icon } from '@iconify/react';

const CartButton = ({ cartCount, onCartOpen }) => {
    return (
        <motion.button
            onClick={onCartOpen}
            className="fixed bottom-6 right-6 z-40 flex items-center gap-2 bg-lime-500 hover:bg-lime-400 text-black p-2 rounded-full shadow-2xl transition-all duration-300 group"
            whileHover={{ scale: 1.05, y: -5 }}
            whileTap={{ scale: 0.95 }}
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
        >
            <div className="relative">
                <Icon icon="solar:cart-large-bold-duotone" className="text-2xl" />
                {cartCount > 0 && (
                    <motion.span
                        key={cartCount}
                        initial={{ scale: 0 }}
                        animate={{ scale: 1 }}
                        className="absolute -top-3 -right-3 bg-red-600 text-white text-[10px] font-bold rounded-full w-5 h-5 flex items-center justify-center border-2 "
                    >
                        {cartCount > 9 ? "9+" : cartCount}
                    </motion.span>
                )}
            </div>
            {/* <span className="font-bold text-sm">Panier</span> */}
        </motion.button>
    );
};

export default CartButton;
